import * as React from "react";
import { Avatar } from "@/components/ui/avatar";
import { useImpersonationDialogContext } from "../ImpersonationContext";

export const TransitionScreen: React.FC = () => {
  const { transitioningUser, isReverting, session, getInitials } = useImpersonationDialogContext();

  if (!transitioningUser && !isReverting) return null;

  const displayUser =
    transitioningUser ||
    (session?.actor
      ? {
          fullName: session.actor.fullName,
          email: session.actor.email,
          photoUrl: session.actor.photoUrl,
        }
      : {
          fullName: "Administrator",
          email: session?.email || "",
          photoUrl: undefined,
        });

  return (
    <div className="flex-1 flex flex-col items-center justify-center p-8 bg-white relative overflow-hidden h-full min-h-[400px]">
      {/* Subtle background ambient glows */}
      <div className="absolute h-64 w-64 rounded-full bg-indigo-50/40 -top-12 -left-12 blur-3xl" />
      <div className="absolute h-64 w-64 rounded-full bg-primary/5 -bottom-12 -right-12 blur-3xl" />

      <div className="relative flex flex-col items-center text-center space-y-6 z-10 animate-in fade-in zoom-in-95 duration-500">
        {/* Spinning/pulsing rings around avatar */}
        <div className="relative">
          <div className="absolute inset-0 rounded-full border-2 border-primary/20 animate-ping" />
          <div className="absolute -inset-3 rounded-full border-2 border-t-primary border-transparent animate-spin duration-1000" />
          <Avatar className="h-24 w-24 border-4 border-white shadow-xl shrink-0">
            <Avatar.Image src={displayUser.photoUrl} alt={displayUser.fullName || ""} />
            <Avatar.Fallback className="bg-primary text-white text-2xl font-bold">
              {getInitials(displayUser.fullName)}
            </Avatar.Fallback>
          </Avatar>
        </div>

        <div className="space-y-2">
          <span className="text-[11px] font-bold text-primary uppercase tracking-widest animate-pulse">
            {isReverting ? "Returning to Your Account" : "Switching Accounts"}
          </span>
          <h3 className="text-2xl font-bold text-slate-800 tracking-tight">{displayUser.fullName}</h3>
          {displayUser.email && <p className="text-sm text-slate-400">{displayUser.email}</p>}
        </div>
      </div>
    </div>
  );
};
